import { mapActions } from 'vuex';
import countries from './countries.json';

export default {
  metaInfo: {
    title: "Entité d'investissement",
  },
  data() {
    return {
      countries,
    };
  },
  created() {
    if (!this.entityId) return;
    this.fetchEntity({ id: this.entityId });
  },
  computed: {
    entityId() {
      return this.$route.params.investmentEntityId;
    },
    computedBackRoute() {
      if (this.entityId) {
        return '/profile';
      }
      return '.';
    },
  },
  methods: {
    ...mapActions('investmentEntity', {
      create: 'create',
      fetchEntity: 'fetch',
      update: 'update',
    }),
    returnToProfile() {
      this.$router.push('/profile');
    },
  },
};
